import {Component, inject, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { NotificationService} from "@fgpp-ui/components";
import {SpinnerComponent} from "../../../../ui-components/spinner/spinner.component";
import {StatusType} from "../models/enums/status-type.enum";
import {TranslateService} from "@ngx-translate/core";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-fx-deal-cancellation-modal',
  templateUrl: './fx-deal-cancellation-modal.component.html',
  styleUrl: './fx-deal-cancellation-modal.component.scss'
})
export class FxDealCancellationModalComponent  {

  offset: string;
  currency: string;
  reason: string;
  expireInterval: string;
  uid: string;
  protected readonly spinnerComponent = SpinnerComponent;
  protected readonly StatusType = StatusType;
  statusType: StatusType;
  protected status;
  showLoader: boolean;
  private timer: any;
  cancelDisabled: boolean = false;
  protected httpClient: HttpClient = inject(HttpClient);
  protected notificationService: NotificationService = inject(NotificationService);
  translationService = inject(TranslateService);

    constructor(public dialogRef: MatDialogRef<FxDealCancellationModalComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
      this.offset = data.offset;
      this.expireInterval = data.expireInterval
      this.currency = data.currency;
      this.uid= data.uid;
      this.startTimer();
    }

    public close() {
      return this.dialogRef.close(null);
    }

    public sendCancellationRequest() {
      this.cancelDisabled = true;
      this.statusType = StatusType.INFO;
      this.status = 'fx_deal_cancellation_modal.cancelling_message';
      this.showLoader = true;
      const payload = {
        offsetAmt: this.offset,
        offsetCcy: this.currency,
        uid: this.uid,
        note: this.reason
      }
      this.httpClient.post('do/fxRateController/CancelDeal', payload).subscribe({
        next: (cancelResponse) => {
          this.showLoader = false;
          this.notificationService.success(this.translationService.instant('fx_deal_cancellation_modal.success_message'));
          return this.dialogRef.close({cancelResponse});
        },
        error:(errorResponse) => {
          clearInterval(this.timer);
          this.showLoader = false;
          this.statusType = StatusType.ERROR;
          if(errorResponse.error.errorCode && errorResponse.error.errorCode === 9034) {
            this.notificationService.error(this.translationService.instant('fx_deal_cancellation.interface_error'));
            return this.dialogRef.close(null);
          } else if (errorResponse.error.errorCode && errorResponse.error.errorCode === 27305) {
            this.status = 'fx_deal_cancellation.invalid_request';
          } else if (errorResponse.error.errorCode && errorResponse.error.errorCode === 13169) {
            this.status = 'fx_deal_cancellation_modal.generic_error';
          } else {
            this.status = 'fx_deal_cancellation_modal.error_message';
          }
          this.cancelDisabled = true;
        }
      });
    }

  private startTimer() {
    let interval = parseInt(this.expireInterval, 10);
    this.timer = setInterval(() => {
      if (interval > 0) {
        interval--;
        this.expireInterval = interval.toString();
      } else {
        //disable cancellation button
        this.statusType = StatusType.INFO;
        this.showLoader = false;
        this.status = 'fx_deal_cancellation_modal.expired_message';
        this.cancelDisabled = true;
        clearInterval(this.timer);
      }
    }, 1000);
  }

  ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

}
